// @flow

import {
  type DecoratedProduct,
  selectCartUUID as selectCartId,
  selectOneProductById,
  selectCartProductOwner,
  selectCartReselleeID as selectCartCustomer,
} from '@gandi/cart';
import {
  selectOneOrganization,
  type Organization as ROrganization,
} from '@gandi/redux-organization';
import type { Organization as SOrganization } from '@gandi/redux-sharing';

import { useAppSelector } from 'src/hooks';
import { selectShopCurrent } from 'src/modules/organization/selectors';
import type { FullState } from 'src/types';

export type OwnProps = {
  productId: string | number,
};

type OwnerProps = {
  product: ?DecoratedProduct,
  currentOrganization: SOrganization | void,
  productOwner: string,
  productOwnerOrg: ?ROrganization,
  cartCustomer: string,
  cartId: string,
};

const selectProductOwnerOrg = (state: FullState): ?ROrganization => {
  const productOwner = selectCartProductOwner(state);
  if (!productOwner) {
    return undefined;
  }

  const productOrg = selectOneOrganization(state, productOwner);
  if (!productOrg) {
    return null;
  }

  return productOrg;
};

export function useOwner(props: OwnProps): OwnerProps {
  const product = useAppSelector(state => selectOneProductById(state, props));
  const currentOrganization = useAppSelector(selectShopCurrent);
  const productOwner = useAppSelector(selectCartProductOwner);
  const productOwnerOrg = useAppSelector(selectProductOwnerOrg);
  const cartCustomer = useAppSelector(selectCartCustomer);
  const cartId = useAppSelector(selectCartId);
  return {
    product,
    currentOrganization,
    productOwner,
    productOwnerOrg,
    cartCustomer,
    cartId,
  };
}
